export default __webpack_public_path__ + "static/media/LogoTicketsOnSale.77491f18.svg";